import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../constants/QueryKeys";
import useApi from "../services/ApiService";
import { User, UserRole } from "../models/User";

export function useUserLookup() {
  const api = useApi();
  const usersQuery = useQuery({
    queryKey: [QUERY_KEYS.USERS, "lookup"],
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append("Roles", UserRole.Admin);
      params.append("Roles", UserRole.Editor);
      params.append("Roles", UserRole.Viewer);
      params.append("FetchAll", "true");
      const response = await api.get<User[]>("/api/Users", { params });
      return response.data;
    },
    staleTime: 10 * 60 * 1000,
    refetchOnMount: false,
  });

  const userMap = useMemo(() => {
    const map = new Map<string, string>();
    if (usersQuery.data) {
      for (const user of usersQuery.data) {
        map.set(user.id, user.username);
      }
    }
    return map;
  }, [usersQuery.data]);

  const getUserName = (id: string | null): string | null => {
    if (!id) return null;
    return userMap.get(id) ?? id;
  };

  return { getUserName };
}
